if (!customElements.get('add-all-to-cart')) {
  customElements.define(
    'add-all-to-cart',
    class AddAllToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add-all-button]');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorElement = this.querySelector('[data-add-all-error]');
        if (this.button) this.button.addEventListener('click', () => this.addAll());
      }

      getVariantIds() {
        return (this.dataset.variantIds || '')
          .split(',')
          .map((id) => Number(id))
          .filter((id) => id > 0);
      }

      getCart() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      getSectionIds(cart) {
        if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
        return cart.getSectionsToRender().map((section) => section.id);
      }

      async postAdd(items, sectionIds) {
        const body = { items };
        if (sectionIds.length) {
          body.sections = sectionIds;
          body.sections_url = window.location.pathname;
        }
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const response = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        return { ok: response.ok, data };
      }

      async addAll() {
        const variantIds = this.getVariantIds();
        if (!variantIds.length || this.button.getAttribute('aria-disabled') === 'true') return;

        this.setLoading(true);
        this.showError('');

        const cart = this.getCart();
        const sectionIds = this.getSectionIds(cart);
        let lastSuccess = null;
        let failedCount = 0;

        try {
          // One request for all products; if Shopify rejects the batch (e.g. one item ran out of stock
          // in the meantime), fall back to adding the products one by one and skip the ones that fail.
          const batch = await this.postAdd(
            variantIds.map((id) => ({ id, quantity: 1 })),
            sectionIds
          );

          if (batch.ok) {
            lastSuccess = batch.data;
          } else {
            for (const id of variantIds) {
              const single = await this.postAdd([{ id, quantity: 1 }], sectionIds);
              if (single.ok) {
                lastSuccess = single.data;
              } else {
                failedCount += 1;
              }
            }
          }
        } catch (error) {
          console.error(error);
        }

        this.setLoading(false);

        if (!lastSuccess) {
          this.showError(this.dataset.errorText);
          return;
        }

        if (failedCount > 0) this.showError(this.dataset.partialText);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'add-all-to-cart', cartData: lastSuccess });
        }

        if (cart && cart.tagName === 'CART-DRAWER' && lastSuccess.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(lastSuccess);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      }

      setLoading(isLoading) {
        this.button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        this.button.classList.toggle('loading', isLoading);
        if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      }

      showError(message) {
        if (!this.errorElement) return;
        this.errorElement.textContent = message || '';
        this.errorElement.hidden = !message;
      }
    }
  );
}
